import {AbstractFilterComponent} from "../filter/abstract-filter-component.js";
import {FilterLabel} from "../filter/components/label.js";

export class CalendarRange extends AbstractFilterComponent {

	constructor(parent, filter, node) {
		if (!node) {
			return;
		}

		super(parent, filter, node);

		this.filter = filter;
		this.calendarInput = node.querySelector('.js-calendar-range');
		this.calendarWrapper = node.querySelector('.js-calendar-range-calendar-wrapper');
		this.calendar = node.querySelector('.js-calendar-range__calendar');
		this.calendarValue = node.querySelector('.js-calendar-range-value');
		this.daysWrapper = node.querySelector('.c-tk-calendar-range__day-wrapper');
		this.days = this.daysWrapper.querySelectorAll('.c-tk-calendar-range__day');
		this.label = node.querySelector('.c-tk-calendar-range__footer-label');
		this.label.textContent = this.calendarValue.dataset.placeholder;
		this.inputFrom = node.querySelector('.js-calendar-range-from');
		this.inputTo = node.querySelector('.js-calendar-range-to');
		this.inputDays = node.querySelector('.js-calendar-range-days');
		this.calendarFlatpickr = null;
		this.calendarTogglers = node.querySelectorAll('.js-calendar-range__toggler');
		this.strictDatesFill = false;
		this.lang = document.querySelector('html').getAttribute('lang') || 'en';
		this.dateFormat = this.lang !== 'hu' ? 'd.m.Y' : 'Y.m.d';

		this.init();
	}

	bindEvents() {
		this.watchInputDays();
		this.bindDaysButtons();
	}

	watchInputDays() {
		const self = this;
		self.inputDays.addEventListener('change', () => {
			self.days.forEach(day => {
				const activeDay = self.daysWrapper.querySelector('.c-tk-calendar-range__day.is-active');

				if (activeDay) {
					activeDay.classList.remove('is-active');
				}

				const newActiveDay = self.getActiveDay();
				if (newActiveDay) {
					newActiveDay.classList.add('is-active');
				}
			});


			self.updateLabel();
		});
	}

	bindDaysButtons() {
		const self = this;
		self.days.forEach(day => {
			const dayToActive = self.getActiveDay();

			if (dayToActive) {
				dayToActive.classList.add('is-active');
			}

			day.addEventListener('click', () => {
				self.inputDays.value = day.dataset.days;

				self.inputDays.dispatchEvent(new Event('change'));
			});
		});
	}

	init() {
		let self = this;

		let defaultDates = [];

		defaultDates = [self.inputFrom.value || null, self.inputTo.value || null];

		this.calendarFlatpickr = window.flatpickr(self.calendarInput, {
			locale: window.flatpickrLocale(),
			static: true,
			mode: "range",
			minDate: "today",
			dateFormat: "Y-m-d",
			allowInput: true,
			altFormat: self.dateFormat,
			showMonths: window.innerWidth >= 768 ? 2 : 1,
			closeOnSelect: false,
			ignoredFocusElements: [window.document.body],
			defaultDate: defaultDates,
			// nextArrow: `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="#icon-arrow-circle-right"></use></svg></span>`,
			// prevArrow: `<span class="icon-svg" aria-hidden="true"><svg class="icon-svg__svg" viewBox="0 0 20 20" width="20" height="20"><use xlink:href="#icon-arrow-circle-left"></use></svg></span>`,

			onChange: (dates, dateStr, instance) => {
				let stringValue = dateStr.replace('do', '-');
				stringValue = stringValue.replace('do', '-');
				instance.element.value = stringValue;

				if (dates[0]) {
					self.inputFrom.value = dates[0].toLocaleDateString('en-CA');
				}

				if (dates[1]) {
					self.inputTo.value = dates[1].toLocaleDateString('en-CA');
				}

				self.updateLabel();
			}
		});

		self.calendarTogglers.forEach(toggler => {
			toggler.addEventListener('click', () => {
				self.calendarWrapper.classList.toggle('is-active');
				self.calendarFlatpickr.open();
			});
		});

		document.addEventListener('click', e => {
			const wrapper = self.calendarValue.parentNode;

			if (e.target !== wrapper && !wrapper.contains(e.target)) {
				self.closeWrapper();
			}
		});

		self.bindEvents();
		self.updateLabel();
	}

	getNode() {
		return this.node;
	}

	updateLabel() {
		this.getLabels();
	}

	getActiveDay() {
		return this.daysWrapper.querySelector('.c-tk-calendar-range__day[data-days="' + this.inputDays.value +'"]');
	}

	childComponentChangedState(child) {
		let self = this;
		// self.update();
		self.componentStateChanged(self);
	}

	getLabels() {
		const self = this;
		const dateFrom = this.inputFrom.value || null;
		const dateTo = this.inputTo.value || null;
		const days = this.inputDays.value || null;
		const daysLabel = this.getActiveDay() ? this.getActiveDay().dataset.label : '';

		const dateFromText = dateFrom ? (new Date(dateFrom).toLocaleDateString('cs-CZ')) : '';
		const dateToText = dateTo ? (new Date(dateTo).toLocaleDateString('cs-CZ')) : '';
		const daysText = (daysLabel ? ' (' + daysLabel + ')' : daysLabel);
		const placeholder = this.calendarValue.dataset.placeholder;

		const dataLabelFrom = this.inputFrom.dataset.labelFrom ? this.inputFrom.dataset.labelFrom : 'Od';
		const dataLabelTo = this.inputTo.dataset.labelTo ? this.inputTo.dataset.labelTo : 'Do';
		const dataLabelDays = this.inputDays.dataset.labelDays ? this.inputDays.dataset.labelDays : 'Termín';

		let text = '';

		let labels = [];


		if (dateFrom) {
			text += dateFromText;

			labels.push(
				new FilterLabel(
					self,
					`${dataLabelFrom}: ${dateFromText}`,
					'inputFrom'
				)
			)
		}

		if (dateTo) {
			text += ` - ${dateToText}`;

			labels.push(
				new FilterLabel(
					self,
					`${dataLabelTo}: ${dateToText}`,
					'inputTo'
				)
			)
		}

		if (dateFrom && dateTo) {
			text += ` ${daysText}`
		}

		if ((dateFrom && dateTo) && days > 0) {
			let daysLabelText = '';
			let elements = document.querySelectorAll('.c-tk-calendar-range__day');
			for (let i = 0; i < elements.length; i++) {
				if (days === elements[i].dataset.days)
					daysLabelText = elements[i].dataset.label;
			}

			labels.push(
				new FilterLabel(
					self,
					`${dataLabelDays}: ${daysLabelText}`,
					'days'
				)
			)
		}

		if (!text) {
			text = placeholder;
		}

		this.label.textContent = text;
		this.calendarValue.textContent = text;

		self.componentStateChanged();

		if (labels.length) {
			return labels;
		}

		return;
	}

	getFormData() {
		let data = {};


		if (this.strictDatesFill) {
			if (this.inputFrom.value && this.inputTo.value) {
				data['dostupnost[od]'] = this.inputFrom.value;
				data['dostupnost[do]'] = this.inputTo.value;
			}
		} else {
			if (this.inputFrom.value) {
				data['dostupnost[od]'] = this.inputFrom.value;
			}

			if (this.inputTo.value) {
				data['dostupnost[do]'] = this.inputTo.value;
			}
		}

		if (this.inputFrom.value && this.inputTo.value && this.inputDays.value !== 0) {
			data['days'] = this.inputDays.value;
		}


		return data;
	}

	closeWrapper() {
		this.calendarWrapper.classList.remove('is-active');

		if (this.strictDatesFill) {
			if (!this.inputFrom.value || !this.inputTo.value) {
				this.inputFrom.value = null;
				this.inputTo.value = null;
				this.days.value = null;
			}
		}

		this.updateLabel();
	}

	labelDismissed(data) {
		let self = this;

		if (self[data.parameters]) {
			self[data.parameters].value = null;
		}

		if (self.strictDatesFill) {
			if (data.parameters === 'inputFrom' || data.parameters === 'inputTo') {
				self.inputFrom.value = null;
				self.inputTo.value = null;
				self.inputDays.value = null;
				self.inputDays.dispatchEvent(new Event('change'));
			}
		} else {
			if (data.parameters === 'inputFrom') {
				self.inputTo.value = null;
			}
		}

		if (data.parameters === 'days') {
			self.inputDays.value = 0;
			self.inputDays.dispatchEvent(new Event('change'));
		}

		if (data.parameters === 'inputFrom' || data.parameters === 'inputTo') {
			self.inputDays.value = 0;
			self.inputDays.dispatchEvent(new Event('change'));
		}


		this.calendarFlatpickr.setDate([self.inputFrom.value || null, self.inputTo.value || null], true)

		self.filter.setForceUpdateMode();
		self.node.dispatchEvent(new CustomEvent('change'));

	}

	setStrictDatesFill(strict) {
		const self = this;
		self.strictDatesFill = strict === true;
	}
}
